export const AppStoreLogo = () => {
  return <img src={require('./app-store.png')} alt='Croppa - Download on the App Store' />;
};
